module.exports = __webpack_public_path__ + "img/info4.7957dc4e.png";